<template>
  <div
    class="game-definition-item text-center">
    <div class="game-definition-header-container">
      <div class="game-definition-header">{{ gameDefinition.name }}</div>
    </div>
    <div class="game-definition-content-container">
      <div class="game-definition-content">
        {{ describeGame(gameDefinition) }}
        <b-button variant="primary" v-on:click="handleSubmit" >Play!</b-button>
        <div class="row">
          <div class="col"><span v-for="(tag, index) in gameDefinition.tags" :tag="tag" :key="index">{{tag}} </span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "GameDefinition",
    props: ["index", "gameDefinition"],
    methods: {
    handleSubmit() {
      this.$router.push({ name: 'roster', params: { gameDefinition: this.gameDefinition }})
    },
    /* eslint-disable no-console */
    describeGame(gameDefinition) {
      console.log(gameDefinition)
      let desc = 'Play '
      switch (gameDefinition.gameCompletionCriteria.completionType) {
        case 'FIXED_ROUNDS':
          desc = desc + gameDefinition.gameCompletionCriteria.amount + ' rounds. '
          break;
        case 'TARGET_SCORE':
          desc = desc + 'until someone reaches ' + gameDefinition.gameCompletionCriteria.amount + ' points. '
          break;
        case 'PLAYER_OUT':
          desc = desc + 'until someone goes out. '
          break;
      }
      switch(gameDefinition.winningScoreType) {
        case 'LOW_SCORE':
          desc = desc + 'Low score wins.'
          break;
        case 'HIGH_SCORE':
          desc = desc + 'High score wins.'
          break;
      }
      return desc
    }
    }
}
</script>

<style scoped>
.game-definition-item {
  width: 300px;
  height: 200px;
  margin: 15px;
  border: 1px solid #c9c9c9;
  border-radius: 6px;
  background-color: #f9fbfb;
  justify-content: flex-start;
  flex-direction: column;
}

.game-definition-header-container {
  color: #000;
  background-color: #c9c9c9;
  display: flex;
  justify-content: center;
  border-radius: 5px 5px 0px 0px;
  padding: 0px 5px 0px 5px;

}

.game-definition-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.game-definition-content-container {
  color: black;
  display: flex;
  justify-content: center;
  padding: 5px;
}

.game-definition-content {
  width: 900px;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  margin: 5px;
}

.btn-success {
  background-color: rgb(13, 83, 13);
}

</style>